import React, { useState, useRef, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import styles from './styles.module.css';
import logo from './../../assets/images/logo-dark-small.png';
import api from '../../service/api';
import { setAuthData, removeAuthData } from '../../service/auth';

const SignIn = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const toast = useRef(null);
    const history = useHistory();

    const handleWithLogin = () => {
        if(email === '' || password === '') 
            return toast.current.show({severity:'warn', summary: 'Atenção', 
                detail:'Preencha e-mail e senha para continuar!', life: 4000});

        setLoading(true);
        api().post('/login', { email, password }).then(response => {
            setLoading(false);
            if(response && response.status === 200 && response.data.result && response.data.data){
                setAuthData(response.data.data);

                if(response.data.data.isadmin) return history.push('/dashboard');

                return history.push('/travel');
            } else toast.current.show({severity:'error', summary: 'Falha na autenticação', 
                detail: (response && response.data && response.data.message) || 
                'Não foi possível realizar a autenticação com este e-mail e senha!', life: 4000});
        }).catch(error => {
            setLoading(false);
            return toast.current.show({severity:'error', summary: 'Falha na autenticação', 
                detail:'Não foi possível realizar a autenticação com este e-mail e senha!', life: 4000});
        });
    }

    const Header = () => {
        return(
            <div className={styles.contentHeader}>
                <img style={{ width: '70%', maxWidth: '300px' }} src={logo} alt="Logo da Ctruck" />
            </div>
        )
    }

    useEffect(function(){
        removeAuthData();
    }, []);

    return (
        <>
            <Toast ref={toast} position="top-right" />
            <div className={styles.appcontent}>
                <div className={styles.container}>
                    <div className={styles.toSell}>
                        <div className={styles.content}>
                            <div>
                                Não possui cadastro? <br/>
                                <strong>FAÇA GRATUITAMENTE AGORA</strong> <br />
                                <Button style={{ marginTop: 30 }} label="Faça o cadastro" className="p-button-rounded" onClick={() => {
                                    history.push('/signup');
                                }} />
                            </div>
                        </div>
                            </div>
                    <div className={styles.myCard}>
                        <Header />
                        <div className={styles.contentForm}>
                            <div>   
                                <label htmlFor="email" className="block">E-mail</label>
                                <span className={"p-input-icon-left " + styles.w100}>
                                    <i className="pi pi-at" />
                                    <InputText id="email" value={email} 
                                        disabled={loading}
                                        onChange={(e) => setEmail(e.target.value)} placeholder="Informe seu e-mail" />
                                </span>
                            </div>

                            <div>   
                                <label htmlFor="password" className="block">Senha</label>
                                <Password id="password" 
                                    disabled={loading}
                                    className={styles.w100}
                                    value={password} toggleMask feedback={false} 
                                    onChange={(e) => setPassword(e.target.value)} placeholder="Informe sua senha" />
                            </div>
                            <div>
                                <Link to="/request/recovery/password">Esqueceu sua senha? Recupere aqui!</Link>
                            </div>
                            <div className={styles.buttonForm}>
                                <Button loading={loading} label={loading ? 'Entrando...' : 'Entrar'} className="p-button-rounded" onClick={handleWithLogin} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SignIn;